import { observer } from "owa-mobx-react";
import { isGlobalFeatureEnabled } from "owa-feature-flags/lib/utils/isFeatureEnabled";
import isWin32StylingEnabled from "owa-theme-win32-style-store/lib/selectors/isWin32StylingEnabled";
import React from "react";
import { statusBar } from "./StatusBar.scss";

type StatusBarProps = {
    targetRef?: React.Ref<HTMLDivElement>;
};

const StatusBar: React.FunctionComponent<StatusBarProps> = observer(function StatusBar({ targetRef, }) {
    if (!isWin32StylingEnabled() || !isGlobalFeatureEnabled("fwk-status-bar")) {
        return null;
    }
    
    return <div className={statusBar} ref={targetRef}/>;
}, "StatusBar");

export default StatusBar;
